import { render, staticRenderFns } from "./ClinicMessage.vue?vue&type=template&id=e2147a9c&"
import script from "./ClinicMessage.vue?vue&type=script&lang=ts&"
export * from "./ClinicMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ClinicMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports